import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import axiosInstance from "../../../services/AxiosInstance";
import swal from "sweetalert";
import { tokenExtractor } from "../../../utils/helper/tokenExtractor";
import { SignJWT, jwtVerify, decodeJwt } from 'jose';

const ShareForm = ({ addCard, setAddCard }) => {
  const [subtypes, setSubTypes] = useState([]);
  const [form, setForm] = useState({ emails: [], userType: "" });
  const [inputValue, setInputValue] = useState("");
  const [formLink, setFormLink] = useState("");
  const [isMedia, setIsMedia] = useState(false);

  useEffect(() => {
    getUserTypes();

    const query = new URLSearchParams(window.location.search);
    if (query.get("type") === "media") {
      setIsMedia(true);
    }
  }, []);

  const getUserTypes = async () => {
    try {
      const response = await axiosInstance.get("/user-sub-type");
      setSubTypes(response.data?.data || []);
    } catch (error) {
      console.error("Error fetching User Types:", error);
    }
  };

  const user_id = () => tokenExtractor()?.id || null;

  const generateFormLink =async (userType) => {
    if (!userType) {
      setFormLink("");
      return;
    }

    const selectedType = subtypes.find(
      (type) => type.sub_category_id === parseInt(userType)
    );

    const userTypeName = selectedType
      ? selectedType.sub_category_name_view.trim().replace(/\s+/g, "_") // Convert spaces to underscores
      : "";

    const payload = { userType, shared_by: user_id() };

    // const token = window.btoa(JSON.stringify(payload));
    
    let token
    try {
      //  token = sign({ user: "JohnDoe", role: "admin" }, 'secret', { algorithm: "HS256" });
      const keyBytes = new TextEncoder().encode("secretKey");
      
      // Create and sign token (minimal configuration)
      console.log("payload",payload)
      token = await new SignJWT(payload)
        .setProtectedHeader({ alg: 'HS256' })
        .sign(keyBytes);
      console.log("token is",token)
    } catch (error) {
        console.error('toekn error1',error)
    }
    


    const baseUrl =
      process.env.REACT_APP_FRONTEND_URL || "http://localhost:3000";

    setFormLink(
      `${baseUrl}/manual-registration?by=${token}&usertype_name=${userTypeName}`
    );
  };

  const shareOnEmail = async (e) => {
    e.preventDefault();

    if (form.emails.length === 0) {
      swal("Error", "Please enter at least one email.", "error");
      return;
    }

    try {
      const response = await axiosInstance.post("/email/send-email", {
        to: { emails: form.emails, shared_by: user_id() },
      });

      if (response.status === 200) {
        swal("Success", "Form Shared Successfully", "success");
        setAddCard(false);
        setForm({ emails: [], userType: "" }); // Reset form
      }
    } catch (error) {
      console.error("Error sharing form:", error);
      swal("Error", "Failed to share the form. Try again.", "error");
    }
  };

  const copyToClipboard = () => {
    if (formLink) {
      navigator.clipboard.writeText(formLink).then(() => {
        swal("Copied!", "Form link copied to clipboard.", "success");
      });
    } else {
      swal("Error", "Form link is not available.", "error");
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter" || e.key === ",") {
      e.preventDefault();
      addEmail();
    }
  };

  const addEmail = () => {
    if (inputValue.trim() === "") return;
    if (form.emails.includes(inputValue.trim())) {
      swal("Error", "Duplicate email not allowed!", "error");
      return;
    }

    setForm((prev) => ({
      ...prev,
      emails: [...prev.emails, inputValue.trim()],
    }));
    setInputValue("");
  };

  const removeEmail = (index) => {
    setForm((prev) => ({
      ...prev,
      emails: prev.emails.filter((_, i) => i !== index),
    }));
  };

  return (
    <Modal
      className="modal fade"
      show={addCard}
      onHide={() => setAddCard(false)}
    >
      <div className="" role="document">
        <div className="">
          <form onSubmit={shareOnEmail}>
            <div className="modal-header">
              <h4 className="modal-title fs-20">Share Manual Form</h4>
              <button
                type="button"
                className="btn-close"
                onClick={() => setAddCard(false)}
              >
                <span></span>
              </button>
            </div>
            <div className="modal-body">
              <div className="add-contact-box">
                <div className="add-contact-content">
                  <div className="row">
                    {/* Multi-Email Input */}
                    <div className="row">
                      <div className="col-lg-12 d-flex flex-column">
                        <label className="text-black font-w500">
                          Enter User Emails{" "}
                          <span className="text-danger">*</span>
                        </label>
                        <div
                          className="form-control d-flex flex-wrap align-items-center"
                          style={{
                            minHeight: "100px",
                            maxHeight: "200px",
                            overflowY: "auto",
                            border: "1px solid #ced4da",
                            borderRadius: "5px",
                            padding: "10px",
                            display: "flex",
                            gap: "5px",
                            backgroundColor: "#fff",
                          }}
                        >
                          {form.emails.map((email, index) => (
                            <span
                              key={index}
                              className="d-flex align-items-center"
                              style={{
                                backgroundColor: "#e9ecef",
                                color: "#000",
                                padding: "8px 12px",
                                borderRadius: "20px",
                                display: "inline-flex",
                                flexWrap: "nowrap",
                                maxWidth: "100%",
                                fontWeight: "bold",
                                whiteSpace: "nowrap",
                              }}
                            >
                              <span style={{ flexGrow: 1 }}>{email}</span>
                              <button
                                type="button"
                                className="btn btn-sm ms-2"
                                onClick={() => removeEmail(index)}
                                style={{
                                  backgroundColor: "#dc3545",
                                  border: "none",
                                  color: "#fff",
                                  fontSize: "14px",
                                  fontWeight: "bold",
                                  cursor: "pointer",
                                  width: "22px",
                                  height: "22px",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  borderRadius: "50%",
                                }}
                              >
                                ×
                              </button>
                            </span>
                          ))}
                          <input
                            type="text"
                            className="border-0 flex-grow-1"
                            placeholder="Type emails"
                            value={inputValue}
                            onChange={(e) => setInputValue(e.target.value)}
                            onKeyDown={handleKeyDown}
                            onBlur={addEmail}
                            style={{
                              flex: 1,
                              minWidth: "150px",
                              border: "none",
                              outline: "none",
                              padding: "5px",
                              backgroundColor: "transparent",
                            }}
                          />
                        </div>
                      </div>

                      <div className="col-lg-12 d-flex flex-column mt-3">
                        <label className="text-black font-w500">
                          Select User Type
                        </label>
                        <select
                          className="form-control"
                          value={form.userType}
                          onChange={(e) => {
                            const selectedType = e.target.value;
                            setForm((prev) => ({
                              ...prev,
                              userType: selectedType,
                            }));
                            generateFormLink(selectedType); // Ensure link updates instantly
                          }}
                        >
                          <option value="">Select Type</option>
                          {subtypes
                            .filter((type) =>
                              isMedia
                                ? type.sub_category_id === 61 ||
                                  type.sub_category_id === 62
                                : true
                            )
                            .map((type) => (
                              <option
                                key={type.sub_category_id}
                                value={type.sub_category_id}
                              >
                                {type.sub_category_name_view.trim()}
                              </option>
                            ))}
                        </select>
                      </div>
                    </div>
                  </div>

                  {form.userType && formLink && (
                    <div className="col-lg-12 mt-3">
                      <label className="text-black font-w500">Copy Link</label>
                      <div className="d-flex align-items-center">
                        <input
                          className="form-control me-2"
                          type="text"
                          value={formLink}
                          readOnly
                        />
                        <button
                          type="button"
                          className="btn btn-primary"
                          onClick={copyToClipboard}
                        >
                          Copy
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>

            {/* Footer Buttons */}
            <div className="modal-footer">
              <button type="submit" className="btn btn-primary">
                Share
              </button>
              <button
                type="button"
                onClick={() => setAddCard(false)}
                className="btn btn-danger"
              >
                <i className="flaticon-delete-1"></i> Discard
              </button>
            </div>
          </form>
        </div>
      </div>
    </Modal>
  );
};

export default ShareForm;
